import Swiper from "swiper/bundle";
import Plyr from 'plyr';

(function ($) {

    //swiper
    let swiper = new Swiper(".section-testimonials .slider-reviews", {
        spaceBetween: 40,
        slidesPerView: 4,
        centeredSlides: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        pagination: {
            el: ".simple-reviews .swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".simple-reviews .swiper-button-next",
            prevEl: ".simple-reviews .swiper-button-prev",
        }, 
        breakpoints: {
            1200: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
            768: {
                slidesPerView: 3.1,
                spaceBetween: 32,
            },
            1: {
                slidesPerView: 2.1,
                spaceBetween: 24,
            },
        }
    });

    //popup
    $(document).ready(function () {
        const modal = $("#videoModal3");
        const videoElement = modal.find("video");
        const player = new Plyr("#player3", {
            fullscreen: { enabled: false }
        });

        player.elements.container.addEventListener("dblclick", (event) => {
            event.stopPropagation();
            event.preventDefault();
        });

        //touch devices
        let lastTap = 0;
        player.elements.container.addEventListener("touchend", (event) => {
            const currentTime = new Date().getTime();
            const tapLength = currentTime - lastTap;

            if (tapLength < 300 && tapLength > 0) {
                event.stopPropagation();
            }

            lastTap = currentTime;
        });

        // insert URL video
        $(".section-testimonials .wrap-video").on("click", function () {
            const videoUrl = $(this).data("video");
            videoElement.attr("src", videoUrl);
        });

        // play video
        modal.on("shown.bs.modal", function () {
            player.play();
        });

        // clear URL video & pause
        modal.on("hidden.bs.modal", function () {
            player.pause();
            videoElement.attr("src", "");
        });
    });


//play video preview on hover
    $(document).ready(function() {
        const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

        $(".section-testimonials .wrap-video video").each(function() {
            const $video = $(this);

            if (isTouchDevice) {
                //$video.removeAttr('autoplay');
            } else {
                $video.removeAttr("autoplay");
                const $wrapVideo = $video.closest(".wrap-video");

                $wrapVideo.on("mouseenter", function() {
                    $video.get(0).play();
                });

                $wrapVideo.on("mouseleave", function() {
                    $video.get(0).pause();
                    //$video.get(0).currentTime = 0; //start video from 0
                });
            }
        });
    });


})(jQuery);